export function calculateStatistics(userOnboardingStats: any[], filter: any) {
  const { fromDate, toDate } = filter;
  const filteredStats = userOnboardingStats.filter((stat: any) => {
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    const statFromDate = new Date(stat.fromDate);
    const statToDate = new Date(stat.toDate);

    const isFromDateMatch = fromDateObj ? statFromDate >= fromDateObj : true;
    const isToDateMatch = toDateObj ? statToDate <= toDateObj : true;

    return isFromDateMatch && isToDateMatch;
  });

  const totalOnboarded = filteredStats.reduce(
    (sum: number, stat: any) => sum + Number(stat.onboardingCount || 0),
    0
  );

  const confirmedUsers = filteredStats
    .filter((stat: any) => stat.onboardingStatus === "confirmed")
    .reduce(
      (sum: number, stat: any) => sum + Number(stat.onboardingCount || 0),
      0
    );

  const courseCompletionCount = filteredStats.reduce(
    (sum: number, stat: any) => sum + Number(stat.courseCompletionCount || 0),
    0
  );

  const genderWiseDistribution = filteredStats.reduce((acc: any, stat: any) => {
    const gender = stat.gender || "Unknown";
    acc[gender] = (acc[gender] || 0) + Number(stat.onboardingCount || 0);
    return acc;
  }, {});

  return {
    totalOnboarded,
    confirmedUsers,
    courseCompletionCount,
    genderWiseDistribution,
  };
}
